import { useMutation } from '@tanstack/react-query';
import api from '@/lib/api';
import type { ApiResponse, Attachment } from '@/types';

interface UploadResponse {
  attachment: Attachment;
  markdown: string; // The markdown string to insert
}

export function useUploadAttachment() {
  return useMutation({
    mutationFn: async (file: File): Promise<UploadResponse> => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post<ApiResponse<Attachment & { url: string }>>('/attachments', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success || !response.data.data) {
        throw new Error(response.data.error?.message || 'Failed to upload file');
      }

      const attachment = response.data.data;

      // Generate markdown based on file type
      let markdown: string;
      if (attachment.mime_type.startsWith('image/')) {
        markdown = `![${attachment.filename}](${attachment.url})`;
      } else {
        markdown = `[${attachment.filename}](${attachment.url})`;
      }

      return {
        attachment,
        markdown,
      };
    },
  });
}
